import cloneDeep from 'lodash/cloneDeep'

export default (session, { payload }) => {
    const emptyModel = {
        items: [],
        itemsById: [],
        indexes: {},
        meta: { maxId: 0 },
    };

    const seatWithoutRow = removeRowSetsFromSeats(payload.Seat);

    session.state = {
        ...payload,
        Sector: cloneDeep({ ...emptyModel, indexes: { hall: {} } }),
        Row: cloneDeep({ ...emptyModel, indexes: { sector: {} } }),
        Seat: seatWithoutRow,
        SectorRows: cloneDeep({ ...emptyModel, indexes: { fromSectorId: {}, toRowId: {} } }),
        RowSeats: cloneDeep({ ...emptyModel, indexes: { fromRowId: {}, toSeatId: {} } }),
        HallSectors: cloneDeep({ ...emptyModel, indexes: { fromHallId: {}, toSectorId: {} } }),
        TicketTypeSeats: cloneDeep({ ...emptyModel, indexes: { fromHallId: {}, toSectorId: {} } }),
    };
};

function removeRowSetsFromSeats(Seat) {
    const { row: rowIndexes, ...seatIndexes } = Seat.indexes;
    const { itemsById, items } = Seat;
    const flatRowIndexes = rowIndexes.flat();
    const itemsByIdWithoutRows = Object.values(itemsById)
        .filter(item => !flatRowIndexes.includes(item.id))
        .reduce((acc, el) => {
            acc[el.id] = el;
            return acc;
        }, {});
    const itemsWithoutRows = items.filter(item => !flatRowIndexes.includes(item))

    return {
        items: itemsWithoutRows,
        itemsById: itemsByIdWithoutRows,
        indexes: { ...seatIndexes, row: {} },
        meta: {
            maxId: Math.max(...itemsWithoutRows),
        },
    };
}
